import marketPlaces from '../constants/MarketPlaces';

export const Property = {
    A11Y_ITERATION_FOR_INLINE_CHOICE: 'A11Y_ITERATION_FOR_INLINE_CHOICE',
    A11Y_ITERATION_FOR_REGIONS: 'A11Y_ITERATION_FOR_REGIONS',
    ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES: 'ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES',
    ENABLE_NOTES_BOX_IN_IOC: 'ENABLE_NOTES_BOX_IN_IOC',
    DEFAULT_ALLOW_STIMULUS_RESIZING: 'DEFAULT_ALLOW_STIMULUS_RESIZING',
    ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK: 'ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK',
    ENABLE_CANDIDATE_TIMEOUT_WARNING: 'ENABLE_CANDIDATE_TIMEOUT_WARNING',
    ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION: 'ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION',
    ENABLE_MONITOR_ALERT_ESSAY_AUTOSAVE_FAIL_RFLAG: 'ENABLE_MONITOR_ALERT_ESSAY_AUTOSAVE_FAIL_RFLAG',
    ENABLE_CKEDITOR_PROCESS_NUMERICAL: 'ENABLE_CKEDITOR_PROCESS_NUMERICAL',
    ENABLE_COLLAPSIBLE_DRAWING_MODAL: 'ENABLE_COLLAPSIBLE_DRAWING_MODAL',
    ENABLE_OLD_CANDIDATE_SKETCH_TOOL: 'ENABLE_OLD_CANDIDATE_SKETCH_TOOL',
    ENABLE_ESSAY_INDENT_IN_PLAYER: 'ENABLE_ESSAY_INDENT_IN_PLAYER',
    ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER: 'ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER',
    ENABLE_ESSAY_RESIZE_FOR_CANDIDATE: 'ENABLE_ESSAY_RESIZE_FOR_CANDIDATE',
    ENABLE_MARKING_WORD_COUNT: 'ENABLE_MARKING_WORD_COUNT',
    ENABLE_PAUSE_WITH_STOP_TIME: 'ENABLE_PAUSE_WITH_STOP_TIME',
    ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING: 'ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING',
    ENABLE_PLAYER_FOOTER_FOR_QUESTION: 'ENABLE_PLAYER_FOOTER_FOR_QUESTION',
    ENABLE_PROCTOR_AUDIO_RECORDING: 'ENABLE_PROCTOR_AUDIO_RECORDING',
    ENABLE_RECORDING_DURATION_COUNTER: 'ENABLE_RECORDING_DURATION_COUNTER',
    ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO: 'ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO',
    ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER: 'ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER',
    ENABLE_SECTION_MANUAL_SELECTION_V2: 'ENABLE_SECTION_MANUAL_SELECTION_V2',
    ENABLE_SHOW_REMAINING_TIME_SECONDS: 'ENABLE_SHOW_REMAINING_TIME_SECONDS',
    ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST: 'ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST',
    ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY: 'ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY',
    ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY: 'ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY',
    HIDE_RESET_RESPONSE_BUTTON_PLAYER: 'HIDE_RESET_RESPONSE_BUTTON_PLAYER',
    HIDE_TOGGLE_HIGHLIGHT_AND_ANNOTATIONS_ICON_PLAYER: 'HIDE_TOGGLE_HIGHLIGHT_AND_ANNOTATIONS_ICON_PLAYER',
    MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS: 'MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS',
    SPELLCHECKER_DEFAULT_LANGUAGE: 'SPELLCHECKER_DEFAULT_LANGUAGE',
    UI_LANGUAGE_OVERRIDE: 'UI_LANGUAGE_OVERRIDE',
    UI_THEME_NAME: 'UI_THEME_NAME',
    ENABLE_PAUSE_ADDITIONAL_MEDIA_MODE: 'ENABLE_PAUSE_ADDITIONAL_MEDIA_MODE',
    ENABLE_VIRTUAL_KEYBOARD_SYMBOLIC_MATH: 'ENABLE_VIRTUAL_KEYBOARD_SYMBOLIC_MATH',
    ENABLE_SYMBOLIC_MATH_FORMAT_IMPROVEMENT: 'ENABLE_SYMBOLIC_MATH_FORMAT_IMPROVEMENT',
    ENABLE_PLAYER_HIDE_NOTES_NOTIFICATION_MESSAGE: 'ENABLE_PLAYER_HIDE_NOTES_NOTIFICATION_MESSAGE',
    ENABLE_LEFT_ALIGN_FLOWCHART_ITEM_TYPE: 'ENABLE_LEFT_ALIGN_FLOWCHART_ITEM_TYPE',
    ENABLE_ENHANCED_WEB_RTC_RECORDING: 'ENABLE_ENHANCED_WEB_RTC_RECORDING',
    ENABLE_SECOND_POPUP_FOR_AUDIO_REWIND_BY_SECTION: 'ENABLE_SECOND_POPUP_FOR_AUDIO_REWIND_BY_SECTION',
    DISABLE_SAVE_SUBMISSION_FILE: 'DISABLE_SAVE_SUBMISSION_FILE',
    ENABLE_STIMULUS_OPTIONS_IN_PRINT_MANAGER: 'ENABLE_STIMULUS_OPTIONS_IN_PRINT_MANAGER',
    ENABLE_EMPTY_CB_PREVIEW_MESSAGE: 'ENABLE_EMPTY_CB_PREVIEW_MESSAGE',
    ENABLE_CUSTOM_CDN_FOR_TEST_CONTENT: 'ENABLE_CUSTOM_CDN_FOR_TEST_CONTENT',
    ENABLE_PCI_BASED_CUSTOM_ASSESSMENT: 'ENABLE_PCI_BASED_CUSTOM_ASSESSMENT',
    ENABLE_STIMULUS_IN_QUESTION: 'ENABLE_STIMULUS_IN_QUESTION',
    ENABLE_TWO_INLINE_GAP_MATCH_AREAS: 'ENABLE_TWO_INLINE_GAP_MATCH_AREAS',
    ENABLE_CANDIDATE_SELECTED_CONTENT_BLOCK: 'ENABLE_CANDIDATE_SELECTED_CONTENT_BLOCK',
    ENABLE_PDF_FOR_IOP: 'ENABLE_PDF_FOR_IOP',
    ENABLE_SKIP_QUESTION_SUBMISSION_REVIEW: 'ENABLE_SKIP_QUESTION_SUBMISSION_REVIEW',
    A11Y_ITERATION_FOR_IIB_SCREEN_READER: 'A11Y_ITERATION_FOR_IIB_SCREEN_READER',
    ENABLE_A11Y_IIB_FOCUS_HANDOFF: 'ENABLE_A11Y_IIB_FOCUS_HANDOFF',
    ENABLE_CB_STIMULUS_SUBMISSION_TAB: 'ENABLE_CB_STIMULUS_SUBMISSION_TAB',
    ENABLE_HIDE_RESPONSE_AREA_SETTING: 'ENABLE_HIDE_RESPONSE_AREA_SETTING',
    ENABLE_HIDE_RESPONSE_AREA_SETTING_IN_DEMO: 'ENABLE_HIDE_RESPONSE_AREA_SETTING_IN_DEMO',
    ENABLE_MANDATORY_QUESTIONS: 'ENABLE_MANDATORY_QUESTIONS',
    ENABLE_PAUSE_RESUME_OPTION_FOR_TEST_TAKER: 'ENABLE_PAUSE_RESUME_OPTION_FOR_TEST_TAKER',
    ENABLE_DEMO_AA_CONTROLS: 'ENABLE_DEMO_AA_CONTROLS',
    PB_RENDER_STYLE: 'PB_RENDER_STYLE',
    ENABLE_MULTIPLE_STIMULI_FOR_PB: 'ENABLE_MULTIPLE_STIMULI_FOR_PB',
    ENABLE_MATH_KEYBOARD_IN_OFFLINE_MODE: 'ENABLE_MATH_KEYBOARD_IN_OFFLINE_MODE',
    ENABLE_IMAGES_LOAD_IN_OFFLINE_MODE_MATCHING_PAIRING: 'ENABLE_IMAGES_LOAD_IN_OFFLINE_MODE_MATCHING_PAIRING',
    ENABLE_PLAYER_TT_NOTES_PANEL_TO_FIXED_WIDTH: 'ENABLE_PLAYER_TT_NOTES_PANEL_TO_FIXED_WIDTH',
    ENABLE_OFFLINE_RESILIENCE_FOR_PDF_VIEWER: 'ENABLE_OFFLINE_RESILIENCE_FOR_PDF_VIEWER',
    ENABLE_PLAYER_IRP_CHECK_BYPASS_ON_LOCKDOWN_EXEMPTION: 'ENABLE_PLAYER_IRP_CHECK_BYPASS_ON_LOCKDOWN_EXEMPTION',
    ENABLE_RICH_TEXT_EDITOR_IN_OFFLINE_MODE: 'ENABLE_RICH_TEXT_EDITOR_IN_OFFLINE_MODE',
    ENABLE_AUTOMATIC_ID_BYPASS: 'ENABLE_AUTOMATIC_ID_BYPASS',
    ENABLE_AUTO_AUDIO_RECORDING: 'ENABLE_AUTO_AUDIO_RECORDING',
};

export const defaultValues = {
    [Property.A11Y_ITERATION_FOR_INLINE_CHOICE]: 0,
    [Property.A11Y_ITERATION_FOR_REGIONS]: 0,
    [Property.DEFAULT_ALLOW_STIMULUS_RESIZING]: false,
    [Property.ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK]: false,
    [Property.ENABLE_CANDIDATE_TIMEOUT_WARNING]: false,
    [Property.ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION]: false,
    [Property.ENABLE_CKEDITOR_PROCESS_NUMERICAL]: true,
    [Property.ENABLE_COLLAPSIBLE_DRAWING_MODAL]: false,
    [Property.ENABLE_ESSAY_INDENT_IN_PLAYER]: false,
    [Property.ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER]: false,
    [Property.ENABLE_MARKING_WORD_COUNT]: false,
    [Property.ENABLE_NOTES_BOX_IN_IOC]: true,
    [Property.ENABLE_PAUSE_WITH_STOP_TIME]: false,
    [Property.ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING]: false,
    [Property.ENABLE_PLAYER_FOOTER_FOR_QUESTION]: false,
    [Property.ENABLE_PROCTOR_AUDIO_RECORDING]: false,
    [Property.ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES]: false,
    [Property.ENABLE_RECORDING_DURATION_COUNTER]: false,
    [Property.ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO]: false,
    [Property.ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER]: false,
    [Property.ENABLE_SECTION_MANUAL_SELECTION_V2]: false,
    [Property.ENABLE_SHOW_REMAINING_TIME_SECONDS]: false,
    [Property.ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST]: false,
    [Property.ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY]: false,
    [Property.ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY]: false,
    [Property.HIDE_RESET_RESPONSE_BUTTON_PLAYER]: false,
    [Property.HIDE_TOGGLE_HIGHLIGHT_AND_ANNOTATIONS_ICON_PLAYER]: false,
    [Property.MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS]: 3 * 60,
    [Property.SPELLCHECKER_DEFAULT_LANGUAGE]: 'auto',
    [Property.UI_LANGUAGE_OVERRIDE]: undefined,
    [Property.ENABLE_MONITOR_ALERT_ESSAY_AUTOSAVE_FAIL_RFLAG]: false,
    [Property.UI_THEME_NAME]: 'default',
    [Property.ENABLE_VIRTUAL_KEYBOARD_SYMBOLIC_MATH]: false,
    [Property.ENABLE_SYMBOLIC_MATH_FORMAT_IMPROVEMENT]: false,
    [Property.ENABLE_ESSAY_RESIZE_FOR_CANDIDATE]: false,
    [Property.ENABLE_PAUSE_ADDITIONAL_MEDIA_MODE]: false,
    [Property.ENABLE_LEFT_ALIGN_FLOWCHART_ITEM_TYPE]: false,
    [Property.ENABLE_PLAYER_HIDE_NOTES_NOTIFICATION_MESSAGE]: false,
    [Property.ENABLE_ENHANCED_WEB_RTC_RECORDING]: false,
    [Property.ENABLE_SECOND_POPUP_FOR_AUDIO_REWIND_BY_SECTION]: false,
    [Property.DISABLE_SAVE_SUBMISSION_FILE]: false,
    [Property.ENABLE_STIMULUS_OPTIONS_IN_PRINT_MANAGER]: false,
    [Property.ENABLE_EMPTY_CB_PREVIEW_MESSAGE]: false,
    [Property.ENABLE_CUSTOM_CDN_FOR_TEST_CONTENT]: false,
    [Property.ENABLE_PCI_BASED_CUSTOM_ASSESSMENT]: false,
    [Property.ENABLE_STIMULUS_IN_QUESTION]: false,
    [Property.ENABLE_TWO_INLINE_GAP_MATCH_AREAS]: true,
    [Property.ENABLE_CANDIDATE_SELECTED_CONTENT_BLOCK]: false,
    [Property.ENABLE_PDF_FOR_IOP]: false,
    [Property.ENABLE_SKIP_QUESTION_SUBMISSION_REVIEW]: false,
    [Property.A11Y_ITERATION_FOR_IIB_SCREEN_READER]: 0,
    [Property.ENABLE_A11Y_IIB_FOCUS_HANDOFF]: false,
    [Property.ENABLE_CB_STIMULUS_SUBMISSION_TAB]: false,
    [Property.ENABLE_HIDE_RESPONSE_AREA_SETTING]: false,
    [Property.ENABLE_HIDE_RESPONSE_AREA_SETTING_IN_DEMO]: false,
    [Property.ENABLE_MANDATORY_QUESTIONS]: false,
    [Property.ENABLE_PAUSE_RESUME_OPTION_FOR_TEST_TAKER]: false,
    [Property.ENABLE_DEMO_AA_CONTROLS]: false,
    [Property.PB_RENDER_STYLE]: marketPlaces.ceq,
    [Property.ENABLE_MULTIPLE_STIMULI_FOR_PB]: false,
    [Property.ENABLE_OLD_CANDIDATE_SKETCH_TOOL]: true,
    [Property.ENABLE_MATH_KEYBOARD_IN_OFFLINE_MODE]: false,
    [Property.ENABLE_IMAGES_LOAD_IN_OFFLINE_MODE_MATCHING_PAIRING]: false,
    [Property.ENABLE_PLAYER_TT_NOTES_PANEL_TO_FIXED_WIDTH]: false,
    [Property.ENABLE_OFFLINE_RESILIENCE_FOR_PDF_VIEWER]: false,
    [Property.ENABLE_PLAYER_IRP_CHECK_BYPASS_ON_LOCKDOWN_EXEMPTION]: false,
    [Property.ENABLE_RICH_TEXT_EDITOR_IN_OFFLINE_MODE]: false,
    [Property.ENABLE_AUTOMATIC_ID_BYPASS]: false,
    [Property.ENABLE_AUTO_AUDIO_RECORDING]: false,
};

const getMPProperty = (propertyName, defaultValue = defaultValues[propertyName]) => {
    return window.marketplaceProperties[propertyName] === undefined ? defaultValue : window.marketplaceProperties[propertyName];
};

const marketplacePropertiesService = {
    isCkeditorProcessNumericalEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_CKEDITOR_PROCESS_NUMERICAL, defaultValue);
    },

    isAnnotatingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_ANNOTATIONS_AND_HIGHLIGHTING, defaultValue);
    },

    getSpellcheckerDefaultLanguage(defaultValue) {
        return getMPProperty(Property.SPELLCHECKER_DEFAULT_LANGUAGE, defaultValue);
    },

    getUiLanguageOverride(defaultValue) {
        return getMPProperty(Property.UI_LANGUAGE_OVERRIDE, defaultValue);
    },

    isPauseWithStopTimeEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PAUSE_WITH_STOP_TIME, defaultValue);
    },

    isResetResponseButtonHidden(defaultValue) {
        return getMPProperty(Property.HIDE_RESET_RESPONSE_BUTTON_PLAYER, defaultValue);
    },

    isRetrievingAssetsDownloadInfoEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_RETRIEVING_ASSETS_DOWNLOAD_INFO, defaultValue);
    },

    getMaxLiveSessionRecoveryTimeSecs(defaultValue) {
        return getMPProperty(Property.MAX_LIVE_SESSION_RECOVERY_WAITING_TIME_SECS, defaultValue);
    },

    isCandidateTimeoutWarningEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_CANDIDATE_TIMEOUT_WARNING, defaultValue);
    },

    isSimplifiedSummaryPageForPublicTestEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_SIMPLIFIED_SUMMARY_PAGE_FOR_PUBLIC_TEST, defaultValue);
    },

    isMarkingWordCountEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_MARKING_WORD_COUNT, defaultValue);
    },

    isTestInformationVideoDependencyEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_TEST_INFORMATION_VIDEO_DEPENDENCY, defaultValue);
    },

    getUiTheme(defaultValue) {
        return getMPProperty(Property.UI_THEME_NAME, defaultValue);
    },

    isCollapsibleDrawingModalEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_COLLAPSIBLE_DRAWING_MODAL, defaultValue);
    },

    isEnableCandidateOldDrawingOption(defaultValue) {
        return getMPProperty(Property.ENABLE_OLD_CANDIDATE_SKETCH_TOOL, defaultValue);
    },

    isProctorAudioRecordingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PROCTOR_AUDIO_RECORDING, defaultValue);
    },

    isStimulusResizingAllowed(defaultValue) {
        return getMPProperty(Property.DEFAULT_ALLOW_STIMULUS_RESIZING, defaultValue);
    },

    isQuestionFooterEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_FOOTER_FOR_QUESTION, defaultValue);
    },

    isSectionManualSelectionV2Enabled(defaultValue) {
        return getMPProperty(Property.ENABLE_SECTION_MANUAL_SELECTION_V2, defaultValue);
    },

    showRemainTimeSeconds(defaultValue) {
        return getMPProperty(Property.ENABLE_SHOW_REMAINING_TIME_SECONDS, defaultValue);
    },

    shouldSanitiseNonPrintableChars(defaultValue) {
        return getMPProperty(Property.ENABLE_SANITISE_NON_PRINTABLE_CHARS_FROM_ANSWER, defaultValue);
    },

    shouldHideGridLinesInAudioScript(defaultValue) {
        return getMPProperty(Property.ENABLE_AUDIOSCRIPT_WITHOUT_GRIDLINES, defaultValue);
    },

    showNotesInIOC(defaultValue) {
        return getMPProperty(Property.ENABLE_NOTES_BOX_IN_IOC, defaultValue);
    },

    isRecordingDurationCounterEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_RECORDING_DURATION_COUNTER, defaultValue);
    },

    getA11yIterationForRegions(defaultValue) {
        return getMPProperty(Property.A11Y_ITERATION_FOR_REGIONS, defaultValue);
    },

    getA11yIterationForInlineChoiceValue(defaultValue) {
        return getMPProperty(Property.A11Y_ITERATION_FOR_INLINE_CHOICE, defaultValue);
    },

    isBackgroundAudioCheckEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_BACKGROUND_AUDIO_PLAYABILITY_CHECK, defaultValue);
    },

    isEssayToolbarIndentEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_ESSAY_INDENT_IN_PLAYER, defaultValue);
    },

    isEssayToolbarTextAlignEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_ESSAY_TEXT_ALIGN_IN_PLAYER, defaultValue);
    },

    isReactMathKeyboardForSymbolicMathEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_VIRTUAL_KEYBOARD_SYMBOLIC_MATH, defaultValue);
    },

    isSymbolicMathFromatImprovementEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_SYMBOLIC_MATH_FORMAT_IMPROVEMENT, defaultValue);
    },

    isNumericDecimalPointEnforced(defaultValue) {
        return getMPProperty(Property.ENFORCE_DECIMAL_POINT_IN_NUMERIC_ENTRY, defaultValue);
    },

    isChromebookDisplayDetectionEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_CHROMEBOOK_ADDITIONAL_DISPLAY_DETECTION, defaultValue);
    },

    isMonitorAlertEssayAutoSaveFailedEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_MONITOR_ALERT_ESSAY_AUTOSAVE_FAIL_RFLAG, defaultValue);
    },

    isToggleHighlightAndAnnotationsIconHidden(defaultValue) {
        return getMPProperty(Property.HIDE_TOGGLE_HIGHLIGHT_AND_ANNOTATIONS_ICON_PLAYER, defaultValue);
    },

    isEssayResizeEnabledForCandidate(defaultValue) {
        return getMPProperty(Property.ENABLE_ESSAY_RESIZE_FOR_CANDIDATE, defaultValue);
    },
    isEnableMediaPauseModeOn(defaultValue) {
        return getMPProperty(Property.ENABLE_PAUSE_ADDITIONAL_MEDIA_MODE, defaultValue);
    },
    isEnablePlayerHideNotesNotificationMessage(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_HIDE_NOTES_NOTIFICATION_MESSAGE, defaultValue);
    },
    isEnableLeftAlignFlowChartItemType(defaultValue) {
        return getMPProperty(Property.ENABLE_LEFT_ALIGN_FLOWCHART_ITEM_TYPE, defaultValue);
    },
    isEnhancedWebRtcRecordingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_ENHANCED_WEB_RTC_RECORDING, defaultValue);
    },
    isSecondPopupEnabledForAudioRewind(defaultValue) {
        return getMPProperty(Property.ENABLE_SECOND_POPUP_FOR_AUDIO_REWIND_BY_SECTION, defaultValue);
    },
    isDisableSaveSubmissionFile(defaultValue) {
        return getMPProperty(Property.DISABLE_SAVE_SUBMISSION_FILE, defaultValue);
    },
    isEnableStimulusOptionsInPrintManager(defaultValue) {
        return getMPProperty(Property.ENABLE_STIMULUS_OPTIONS_IN_PRINT_MANAGER, defaultValue);
    },
    isEnableEmptyCBPreviewMessage(defaultValue) {
        return getMPProperty(Property.ENABLE_EMPTY_CB_PREVIEW_MESSAGE, defaultValue);
    },
    isEnableCustomCdnForTestContent(defaultValue) {
        return getMPProperty(Property.ENABLE_CUSTOM_CDN_FOR_TEST_CONTENT, defaultValue);
    },
    isPciBasedCustomAssessmentEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PCI_BASED_CUSTOM_ASSESSMENT, defaultValue);
    },
    isEnableStimulusInQuestion(defaultValue) {
        return getMPProperty(Property.ENABLE_STIMULUS_IN_QUESTION, defaultValue);
    },
    isEnableTwoInlineGapMatchAreas(defaultValue) {
        return getMPProperty(Property.ENABLE_TWO_INLINE_GAP_MATCH_AREAS, defaultValue);
    },
    isEnableCandidateSelectedContentBlock(defaultValue) {
        return getMPProperty(Property.ENABLE_CANDIDATE_SELECTED_CONTENT_BLOCK, defaultValue);
    },
    isPdfForIopEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PDF_FOR_IOP, defaultValue);
    },
    isSkipQuestionSubmissionReviewEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_SKIP_QUESTION_SUBMISSION_REVIEW, defaultValue);
    },
    isHideResponseAreaSettingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_HIDE_RESPONSE_AREA_SETTING, defaultValue);
    },
    isHideResponseAreaSettingEnabledInDemoTest(defaultValue) {
        return getMPProperty(Property.ENABLE_HIDE_RESPONSE_AREA_SETTING_IN_DEMO, defaultValue);
    },
    getA11yIterationForIIBScreenReader(defaultValue) {
        return getMPProperty(Property.A11Y_ITERATION_FOR_IIB_SCREEN_READER, defaultValue);
    },
    isEnableA11yIIBFocusHandoff(defaultValue) {
        return getMPProperty(Property.ENABLE_A11Y_IIB_FOCUS_HANDOFF, defaultValue);
    },
    isEnableCbStimulusSubmissionTab(defaultValue) {
        return getMPProperty(Property.ENABLE_CB_STIMULUS_SUBMISSION_TAB, defaultValue);
    },
    isMandatoryQuestionEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_MANDATORY_QUESTIONS, defaultValue);
    },
    isPauseResumeOptionForTestTakerEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PAUSE_RESUME_OPTION_FOR_TEST_TAKER, defaultValue);
    },
    isDemoAAControlsEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_DEMO_AA_CONTROLS, defaultValue);
    },
    getPbRenderStyle(defaultValue) {
        return getMPProperty(Property.PB_RENDER_STYLE, defaultValue);
    },
    isMultipleStimuliForPbEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_MULTIPLE_STIMULI_FOR_PB, defaultValue);
    },
    isSymbolicMathKeyboardInOfflineModeEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_MATH_KEYBOARD_IN_OFFLINE_MODE, defaultValue);
    },
    isImagesLoadInMatchingPairingOfflineModeEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_IMAGES_LOAD_IN_OFFLINE_MODE_MATCHING_PAIRING, defaultValue);
    },
    isNotesPanelFixedWidthEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_TT_NOTES_PANEL_TO_FIXED_WIDTH, defaultValue);
    },
    isOfflineResilienceForPdfViewerEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_OFFLINE_RESILIENCE_FOR_PDF_VIEWER, defaultValue);
    },
    isPlayerIrpCheckBypassOnLockdownExemptionEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_PLAYER_IRP_CHECK_BYPASS_ON_LOCKDOWN_EXEMPTION, defaultValue);
    },
    isOfflineResilienceForCkEditorEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_RICH_TEXT_EDITOR_IN_OFFLINE_MODE, defaultValue);
    },
    isAutomaticIdBypassEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_AUTOMATIC_ID_BYPASS, defaultValue);
    },
    isAutoAudioRecordingEnabled(defaultValue) {
        return getMPProperty(Property.ENABLE_AUTO_AUDIO_RECORDING, defaultValue);
    },
};
export default marketplacePropertiesService;
